import React from 'react';
import {MoonLoader} from 'react-spinners';
import '../css_files/loader.css';

const LoaderWheel = () =>{
        return (
            <>
            <MoonLoader
                color={'#004D72'}
                size={150}
                cssOverride={{ display: 'block', margin: '0 auto' , marginTop:'5%'}}
                speedMultiplier={0.66}
                    
            />
            <h1 className='moon-loader'> Data is Loading </h1>
            </>
        )
    }

export default LoaderWheel;